import { render, staticRenderFns } from "./CostBreakdownWidget.vue?vue&type=template&id=be97e2d6&"
import script from "./CostBreakdownWidget.vue?vue&type=script&lang=js&"
export * from "./CostBreakdownWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports